/**
 * NutriPeak — Floating Product Video
 * Teaser (muted autoplay) → popup player (sound + controls) + native Add to Cart.
 * The popup ATC proxy-clicks the theme's real add button (selected variant + cart drawer).
 */
(function () {
  'use strict';

  var teardowns = [];
  function cleanup() { teardowns.forEach(function (f) { try { f(); } catch (e) {} }); teardowns = []; }

  function init(scope) {
    var root = (scope && scope.querySelector) ? scope : document;
    var els = root.querySelectorAll('[data-np-pvideo]');
    for (var i = 0; i < els.length; i++) setup(els[i]);
  }

  function setup(root) {
    if (root.dataset.npReady === '1') return;
    cleanup();
    root.dataset.npReady = '1';

    var kind = root.getAttribute('data-kind');                 // file | mp4 | embed
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var dismissible = root.getAttribute('data-dismissible') === 'true';
    var draggable = root.getAttribute('data-draggable') === 'true';
    var productUrl = root.getAttribute('data-product-url') || '/';

    var fab = root.querySelector('.np-pvideo__fab');
    var fabBtn = root.querySelector('[data-np-open]');
    var dismissBtn = root.querySelector('[data-np-dismiss]');
    var teaserVideo = root.querySelector('[data-np-video]');       // teaser (muted loop, stays)
    var modalVideo = root.querySelector('[data-np-modal-video]');  // popup (sound, plays from start)
    var overlay = root.querySelector('[data-np-overlay]');
    var modal = root.querySelector('[data-np-modal]');
    var player = root.querySelector('[data-np-player]');
    var embed = root.querySelector('[data-np-embed]');
    var muteBtn = root.querySelector('[data-np-mute]');
    var playBtn = root.querySelector('[data-np-playpause]');
    var shareBtn = root.querySelector('[data-np-share]');
    var closeBtn = root.querySelector('[data-np-close]');
    var atcBtn = root.querySelector('[data-np-atc]');
    var nowEl = root.querySelector('[data-np-now]');
    var wasEl = root.querySelector('[data-np-was]');

    if (!modal) return; // popup markup is required

    /* ---------- teaser autoplay ---------- */
    function playTeaser() {
      if (!teaserVideo || !autoplay) return;
      teaserVideo.muted = true;
      var p = teaserVideo.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (teaserVideo) {
      // pause when scrolled out of view to save resources
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) {
          if (modal && modal.hasAttribute('hidden')) { // only manage the teaser when popup is closed
            if (e[0].isIntersecting) playTeaser(); else teaserVideo.pause();
          }
        }, { threshold: 0.1 });
        io.observe(fab);
        teardowns.push(function () { io.disconnect(); });
      }
      playTeaser();
    }

    /* ---------- icon helpers ---------- */
    function swap(btn, onSel, offSel, on) {
      if (!btn) return;
      var a = btn.querySelector(onSel), b = btn.querySelector(offSel);
      // SVGElement has no `hidden` IDL property — toggle the ATTRIBUTE (CSS [hidden] handles display)
      if (a) { if (on) a.removeAttribute('hidden'); else a.setAttribute('hidden', ''); }
      if (b) { if (on) b.setAttribute('hidden', ''); else b.removeAttribute('hidden'); }
    }
    function refreshIcons() {
      if (!modalVideo) return;
      swap(muteBtn, '.np-pv-ic-unmute', '.np-pv-ic-mute', !modalVideo.muted);
      swap(playBtn, '.np-pv-ic-pause', '.np-pv-ic-play', !modalVideo.paused);
    }

    /* ---------- open / close popup ---------- */
    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      if (kind === 'embed') {
        if (embed && !embed.src && embed.dataset.src) embed.src = embed.dataset.src;
      } else if (modalVideo) {
        modalVideo.currentTime = 0;                // always start from the beginning
        modalVideo.muted = false;
        var p = modalVideo.play();
        // iOS can reject an unmuted play() — fall back to muted playback so it still plays
        if (p && p.catch) p.catch(function () { modalVideo.muted = true; var p2 = modalVideo.play(); if (p2 && p2.catch) p2.catch(function () {}); refreshIcons(); });
        refreshIcons();
      }
      overlay.removeAttribute('hidden');
      modal.removeAttribute('hidden');
      document.documentElement.classList.add('np-pv-lock');
      document.addEventListener('keydown', onKeydown);
      setTimeout(function () { (closeBtn || modal).focus(); }, 60);
    }

    function closeModal() {
      if (modal.hasAttribute('hidden')) return;
      var sm = root.querySelector('[data-np-share-menu]'); if (sm) sm.setAttribute('hidden', ''); // reset share menu
      overlay.setAttribute('hidden', '');
      modal.setAttribute('hidden', '');
      document.documentElement.classList.remove('np-pv-lock');
      document.removeEventListener('keydown', onKeydown);
      if (kind === 'embed') {
        if (embed) embed.src = '';                 // stop playback
      } else if (modalVideo) {
        modalVideo.pause();
        modalVideo.currentTime = 0;
      }
      // the teaser keeps looping muted the whole time — nothing to reset
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
      lastFocus = null;
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) { closeModal(); return; }
      if (e.key !== 'Tab') return;
      var f = modal.querySelectorAll('button, [href], iframe, [tabindex]:not([tabindex="-1"])');
      f = [].filter.call(f, function (el) { return !el.disabled && el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ---------- controls ---------- */
    var lastDragEnd = 0;
    if (fabBtn) fabBtn.addEventListener('click', function () {
      if (Date.now() - lastDragEnd < 250) return; // swallow the click that ends a drag
      openModal();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);

    if (muteBtn && modalVideo) muteBtn.addEventListener('click', function () {
      modalVideo.muted = !modalVideo.muted; refreshIcons();
    });
    if (playBtn && modalVideo) playBtn.addEventListener('click', function () {
      if (modalVideo.paused) { var p = modalVideo.play(); if (p && p.catch) p.catch(function () {}); }
      else modalVideo.pause();
      // icons update via the 'play'/'pause' listeners below
    });
    if (modalVideo) {
      modalVideo.addEventListener('play', refreshIcons);
      modalVideo.addEventListener('pause', refreshIcons);
    }

    /* ---------- share menu ---------- */
    var shareWrap = root.querySelector('[data-np-share-wrap]');
    var shareMenu = root.querySelector('[data-np-share-menu]');
    var copyBtn = root.querySelector('[data-np-copy]');
    var copyLabel = root.querySelector('[data-np-copy-label]');
    var nativeBtn = root.querySelector('[data-np-native]');

    function shareUrl() { return location.origin + productUrl; }
    function buildShareLinks() {
      var u = encodeURIComponent(shareUrl());
      var t = encodeURIComponent(document.title || '');
      var map = {
        whatsapp: 'https://wa.me/?text=' + t + '%20' + u,
        x: 'https://twitter.com/intent/tweet?url=' + u + '&text=' + t,
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
        telegram: 'https://t.me/share/url?url=' + u + '&text=' + t
      };
      if (shareMenu) shareMenu.querySelectorAll('a[data-net]').forEach(function (a) { a.href = map[a.getAttribute('data-net')] || '#'; });
    }
    function closeShareMenu() { if (shareMenu) shareMenu.setAttribute('hidden', ''); }
    function onDocClickShare(e) { if (shareMenu && !shareMenu.hasAttribute('hidden') && shareWrap && !shareWrap.contains(e.target)) closeShareMenu(); }

    if (shareBtn && shareMenu) {
      if (nativeBtn && navigator.share) nativeBtn.removeAttribute('hidden'); // Insta/TikTok etc. via OS sheet (mobile)
      shareBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        buildShareLinks();
        if (shareMenu.hasAttribute('hidden')) shareMenu.removeAttribute('hidden'); else shareMenu.setAttribute('hidden', '');
      });
      shareMenu.querySelectorAll('a[data-net]').forEach(function (a) { a.addEventListener('click', closeShareMenu); });
      if (copyBtn) copyBtn.addEventListener('click', function () {
        var url = shareUrl();
        var done = function () { if (copyLabel) { var o = copyLabel.textContent; copyLabel.textContent = 'Copied!'; setTimeout(function () { copyLabel.textContent = o; closeShareMenu(); }, 1100); } else closeShareMenu(); };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done).catch(done);
        else { var ta = document.createElement('textarea'); ta.value = url; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e2) {} document.body.removeChild(ta); done(); }
      });
      if (nativeBtn) nativeBtn.addEventListener('click', function () {
        if (navigator.share) navigator.share({ title: document.title, url: shareUrl() }).catch(function () {});
        closeShareMenu();
      });
      document.addEventListener('click', onDocClickShare);
      teardowns.push(function () { document.removeEventListener('click', onDocClickShare); });
    }

    /* ---------- dismiss (hides for this page load; returns on refresh) ---------- */
    if (dismissBtn) dismissBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      root.style.display = 'none';
      if (teaserVideo) teaserVideo.pause();
    });

    /* ---------- draggable (Pointer Events — no library, mouse + touch + pen) ----------
       No setPointerCapture: capture would re-target the follow-up `click` to the fab and
       swallow the tap-to-open. We track moves on `document` instead, so the click still fires. */
    if (draggable && fab && 'PointerEvent' in window) {
      var posKey = 'np-pv-pos:' + productUrl;
      var sx, sy, ox, oy, dragging = false, activeId = null;
      var MARGIN = 8, THRESHOLD = 5;
      var clamp = function (v, lo, hi) { return Math.max(lo, Math.min(hi, v)); };

      function place(x, y) {
        var w = fab.offsetWidth, h = fab.offsetHeight;
        x = clamp(x, MARGIN, window.innerWidth - w - MARGIN);
        y = clamp(y, MARGIN, window.innerHeight - h - MARGIN);
        fab.style.animation = 'none';      // drop the entrance animation so it can't fight inline pos
        fab.style.transform = 'none';
        fab.style.left = x + 'px'; fab.style.top = y + 'px';
        fab.style.right = 'auto'; fab.style.bottom = 'auto';
        fab.dataset.placed = '1';
      }

      // restore where the shopper last placed it (this browsing session)
      try { var sv = JSON.parse(sessionStorage.getItem(posKey) || 'null'); if (sv) place(sv.x, sv.y); } catch (e) {}

      function onMove(e) {
        if (e.pointerId !== activeId) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (!dragging && (Math.abs(dx) > THRESHOLD || Math.abs(dy) > THRESHOLD)) {
          dragging = true; fab.classList.add('np-pv-dragging');
        }
        if (dragging) { e.preventDefault(); place(ox + dx, oy + dy); }
      }
      function onUp(e) {
        if (e.pointerId !== activeId) return;
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('pointercancel', onUp);
        activeId = null;
        if (dragging) {
          dragging = false; lastDragEnd = Date.now();
          fab.classList.remove('np-pv-dragging');
          try { sessionStorage.setItem(posKey, JSON.stringify({ x: parseFloat(fab.style.left), y: parseFloat(fab.style.top) })); } catch (e2) {}
        }
      }
      fab.addEventListener('pointerdown', function (e) {
        if (e.button != null && e.button > 0) return;          // primary button / touch only
        if (e.target.closest('[data-np-dismiss]')) return;     // don't drag when grabbing the close X
        var r = fab.getBoundingClientRect();
        ox = r.left; oy = r.top; sx = e.clientX; sy = e.clientY;
        dragging = false; activeId = e.pointerId;
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
        document.addEventListener('pointercancel', onUp);
      });

      var onResize = function () { if (fab.dataset.placed) place(parseFloat(fab.style.left), parseFloat(fab.style.top)); };
      window.addEventListener('resize', onResize);
      teardowns.push(function () {
        window.removeEventListener('resize', onResize);
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('pointercancel', onUp);
      });
    }

    /* ---------- native Add to Cart (proxy-click) ---------- */
    // scope to the MAIN product (the .product-summary class is shared by quickview/header/etc.)
    var summary = document.querySelector('.main-product-section .product-summary') || document.querySelector('.product-summary');
    var mainForm = summary && summary.querySelector('form[data-type="add-to-cart-form"]');
    var mainAddBtn = mainForm && mainForm.querySelector('button[name="add"].add-to-cart-button');
    var atcLabel = atcBtn && atcBtn.querySelector('[data-np-atc-label]');
    var atcText = atcLabel ? atcLabel.textContent : 'Add to Cart';
    var busy = false, safety = null;

    function isUnavail() {
      return (mainAddBtn && mainAddBtn.classList.contains('disabled')) || (mainForm && mainForm.classList.contains('disabled'));
    }
    function setAtcState(available) {
      if (!atcBtn) return;
      atcBtn.classList.toggle('is-disabled', !available);
      if (atcLabel) atcLabel.textContent = available ? atcText : 'Sold out';
    }
    function succeed() {
      if (!busy) return;
      busy = false; clearTimeout(safety);
      if (atcBtn) { atcBtn.classList.remove('is-loading'); atcBtn.classList.add('is-added'); }
      setTimeout(closeModal, 350);
      setTimeout(function () { if (atcBtn) atcBtn.classList.remove('is-added'); }, 1800);
    }

    if (atcBtn) {
      setAtcState(!isUnavail());

      atcBtn.addEventListener('click', function () {
        if (!mainAddBtn) { window.location.href = productUrl; return; }
        if (busy || isUnavail()) return;
        busy = true; atcBtn.classList.add('is-loading');
        clearTimeout(safety);
        safety = setTimeout(function () { busy = false; atcBtn.classList.remove('is-loading'); }, 6000); // failure reset
        mainAddBtn.click();
      });

      // success signal #1 — theme opened the side cart (class flips to present)
      var htmlObs = new MutationObserver(function () {
        if (busy && document.documentElement.classList.contains('side-cart-open')) succeed();
      });
      htmlObs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      teardowns.push(function () { htmlObs.disconnect(); });

      // success signal #2 — cart count changed (covers an already-open drawer)
      var cc = document.querySelector('.cart-item-count');
      if (cc) {
        var ccObs = new MutationObserver(function () { if (busy) succeed(); });
        ccObs.observe(cc, { childList: true, characterData: true, subtree: true });
        teardowns.push(function () { ccObs.disconnect(); });
      }
    }

    /* ---------- keep the card price in sync with variant ---------- */
    function formatMoney(cents) {
      var format = (window.btyGlobals && window.btyGlobals.money_format) || '{{amount}}';
      function fwd(num, prec, th, dec) {
        th = th == null ? ',' : th; dec = dec == null ? '.' : dec;
        if (isNaN(num) || num == null) return '0';
        var parts = (num / 100).toFixed(prec).split('.');
        return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (parts[1] ? dec + parts[1] : '');
      }
      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, n) {
        switch (n) {
          case 'amount_no_decimals': return fwd(cents, 0);
          case 'amount_with_comma_separator': return fwd(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fwd(cents, 0, '.', ',');
          case 'amount_with_space_separator': return fwd(cents, 2, ' ', '.');
          case 'amount_with_apostrophe_separator': return fwd(cents, 2, "'", '.');
          default: return fwd(cents, 2);
        }
      });
    }
    var onVariant = function (e) {
      var v = e && e.detail && e.detail.selected; if (!v) return;
      setAtcState(!!v.available);                       // keep the popup ATC in sync with stock
      if (nowEl) {
        nowEl.textContent = formatMoney(v.price);
        if (wasEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = formatMoney(v.compare_at_price); wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
      }
    };
    document.addEventListener('product-variant-updated', onVariant);
    teardowns.push(function () { document.removeEventListener('product-variant-updated', onVariant); });

    // make re-init (theme editor) clean: clear pending timer, modal keydown, scroll lock
    teardowns.push(function () {
      clearTimeout(safety);
      document.removeEventListener('keydown', onKeydown);
      document.documentElement.classList.remove('np-pv-lock');
    });
  }

  /* ---------- boot ---------- */
  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target.querySelector ? e.target : document;
    var b = t.querySelector ? t.querySelector('[data-np-pvideo]') : null;
    if (b) b.dataset.npReady = '';
    init(t);
  });
})();
